import { ChangeDetectionStrategy, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    confirmText: string,
    title: string,
    details: {
      message: string,
      value?: string[];
      links?: { label: string; url: string }[];
    }[];
  }, private mdDialogRef: MatDialogRef<AlertDialogComponent>) { }
  openLink(event: Event, url: string) {
    event.preventDefault();
    if (url) {
      window.open(url, '_blank');
    }
  }
  public close(value) {
    this.mdDialogRef.close(value);
  }
  public confirm() {
    this.close(true);
  }
  @HostListener("keydown.esc")
  public onEsc() {
    this.close(false);
  }
  ngOnInit() {
  }
}
